import React from 'react';
import { Helmet } from 'react-helmet-async';
import { Link, useParams } from 'react-router-dom';
import posts from '../data/BlogPosts.json';
import './Blog.css';

function formatDate(dateStr) {
  if (!dateStr) return '';
  const d = new Date(dateStr);
  if (Number.isNaN(d.getTime())) return dateStr;
  return d.toLocaleDateString('en-GB', { day: 'numeric', month: 'long', year: 'numeric' });
}

function BlogPost() {
  const { slug } = useParams();
  const post = posts.find((p) => p.slug === slug);

  if (!post) {
    return (
      <div className="blog-page">
        <Helmet>
          <title>Post not found - Szakacs Visuals</title>
          <meta name="robots" content="noindex" />
        </Helmet>
        <div className="blog-post-notfound">
          <h1>Post not found</h1>
          <p>The article you're looking for doesn't exist or may have been moved.</p>
          <Link to="/blog" className="get-in-touch-btn">BACK TO BLOG</Link>
        </div>
      </div>
    );
  }

  const url = `https://szakacsvisuals.co.uk/blog/${post.slug}`;

  return (
    <div className="blog-page">
      <Helmet>
        <title>{post.title} - Szakacs Visuals</title>
        <meta name="description" content={post.metaDescription || post.excerpt} />
        {post.keywords && <meta name="keywords" content={post.keywords.join(', ')} />}
        <meta property="og:title" content={post.title} />
        <meta property="og:description" content={post.metaDescription || post.excerpt} />
        <meta property="og:type" content="article" />
        <meta property="og:url" content={url} />
        {post.image && <meta property="og:image" content={`https://szakacsvisuals.co.uk${post.image}`} />}
        <link rel="canonical" href={url} />
      </Helmet>

      <article className="blog-post">
        <div className="blog-post-hero" style={{ backgroundImage: `url(${post.image})` }} role="img" aria-label={post.title} />
        <div className="blog-post-content">
          <Link to="/blog" className="blog-post-back">&larr; BACK TO BLOG</Link>
          <span className="blog-card-date">{formatDate(post.date)}{post.author ? ` · ${post.author}` : ''}</span>
          <h1>{post.title}</h1>
          {Array.isArray(post.content)
            ? post.content.map((paragraph, idx) => <p key={idx}>{paragraph}</p>)
            : <p>{post.content}</p>}
        </div>
      </article>
    </div>
  );
}

export default BlogPost;
